import { APIGet } from "utilities/APIRequestHelper"
import apiURLBuilder from "core/apiURLBuilder"
import actionTypes from "constants/actionTypes"
import { downloadFileFromUrl } from "utilities/fileDownloadHelper"
import { formatDate } from "utilities/dateHelper"
import { CONTRACTUAL_TYPES } from "constants/contractualDocuments"

const getPreContractualsInProgress = () => ({
    type: actionTypes.FETCH_PRE_CONTRACTUALS_OK_REQUEST,
})

const getPreContractualsSuccess = (response) => ({
    type: actionTypes.FETCH_PRE_CONTRACTUALS_OK_SUCCESS,
    payload: {
        precontracts: response,
    },
})

const getPreContractualsFailure = (error) => ({
    type: actionTypes.FETCH_PRE_CONTRACTUALS_OK_API_FAILURE,
    payload: {
        error,
    },
})

const getContractualOverdraftProtectionInProgress = () => ({
    type: actionTypes.FETCH_CONTRACTUALS_OVERDRAFT_PROTECTION_IN_PROGRESS,
})

const getContractualOverdraftProtectionError = () => ({
    type: actionTypes.FETCH_CONTRACTUALS_OVERDRAFT_PROTECTION_ERROR,
})

const getContractualOverdraftProtectionSuccess = (contractId, response) => ({
    type: actionTypes.FETCH_CONTRACTUALS_OVERDRAFT_PROTECTION_SUCCESS,
    payload: {
        contractId,
        data: response,
    },
})

const updateIsFetchingOverdraftInProgress = ({ documentId, contractId }) => ({
    type: actionTypes.UPDATE_IS_FETCHING_OVERDRAFT_FILE,
    payload: {
        documentId,
        contractId,
        value: true
    },
})

const updateIsFetchingOverdraftFinish = ({ documentId, contractId }) => ({
    type: actionTypes.UPDATE_IS_FETCHING_OVERDRAFT_FILE,
    payload: {
        documentId,
        contractId,
        value: false
    },
})

const getPreContractualsOkApi = (callBack, contract) => (dispatch) => {
    dispatch(getPreContractualsInProgress())
    let requestData = {
        query: {
            category: "cat_precontractual",
            contract
        },
    }
    return APIGet(
        dispatch,
        apiURLBuilder.getURL("apiDocumentsDms"),
        requestData,
    )
    .then((response) => {
        if (response) {
            dispatch(getPreContractualsSuccess(response))
        } else {
            dispatch(getPreContractualsFailure())
            callBack()
        }
    })
    .catch((error) => {
        dispatch(getPreContractualsFailure(error))
        callBack()
    })
}


const getDocumentsOkApiById = (documentId, callback = () => {}, open = false) => (dispatch) => {
    return APIGet(
        dispatch,
        apiURLBuilder.getURL("apiDocumentById", { documentId }),
    )
    .then((response) => {
        if (response && response.documentUri) {
            if (open) {
                window.open(response.documentUri, '_blank')
            } else {
                downloadFileFromUrl(response.documentUri, response.documentName)
            }
            callback()
        } else {
            return
        }
    })
    .catch(() => {
        return
    })
}

const getContractualOverdraftProtection = (contract) => (dispatch) => {
    const requestData = {
        query: {
            contract,
            documentType: "LE552",
            uploadStatus: "UPLOADED",
            clientVisible: true,
        },
    }

    dispatch(getContractualOverdraftProtectionInProgress())
    return APIGet(
        dispatch,
        apiURLBuilder.getURL("apiDocumentsDms"),
        requestData,
    )
    .then((response) => {
        const mappedDocs = response.documents.map((doc) => {
            return {
                fechaAlta: `${formatDate(doc.registrationDate, "YYYYMMDD")}`,
                nombreTipoComunicacion: doc.documentName.replace(doc.fileExtension, ""),
                file: { documentId: doc.documentId, type: CONTRACTUAL_TYPES.overdraft },
                isFetching: false,
            }
        })
        dispatch(getContractualOverdraftProtectionSuccess(contract, mappedDocs))
    })
    .catch(() => {
        dispatch(getContractualOverdraftProtectionError())
    })
}

module.exports = {
    getPreContractualsOkApi,
    getDocumentsOkApiById,
    getContractualOverdraftProtection,
    updateIsFetchingOverdraftInProgress,
    updateIsFetchingOverdraftFinish,
}
